module.exports = __webpack_public_path__ + "../resources/img/mon_graph_img2.edf0332a.png";